import { FC, FormEvent, useCallback, useState } from 'react';

import { Button, Input, Label, Text } from '@olist/united';

import { bff } from 'modules/bff';
import { Form as FormElement } from 'modules/components/Form';
import { Link } from 'modules/components/Link';
import { ROUTES } from 'modules/routes';

interface Props {
  onSuccess: (email: string) => void;
}

export const Form: FC<Props> = ({ onSuccess }) => {
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(false);

  const onSubmit = useCallback(
    async (event: FormEvent) => {
      setSubmitted(true);

      // @ts-ignore
      const { email } = event.currentTarget.elements;

      try {
        await bff.post('/reset-password', {
          email: email.value,
        });

        onSuccess(email.value);
      } catch {
        setError(true);
      }

      setSubmitted(false);
    },
    [onSuccess]
  );

  return (
    <FormElement onSubmit={onSubmit}>
      <Text color="secondary" fontSize={16}>
        Não se preocupe. Insira seu e-mail e receba as instruções de redefinição de senha.
      </Text>
      <div style={{ margin: '16px 0' }}>
        <Label>E-mail:</Label>
        <Input error={error} required type="email" name="email" disabled={submitted} />
      </div>
      <Link href={{ pathname: ROUTES.SIGNIN }} tabIndex={-1}>
        Voltar para a tela de login
      </Link>
      <div style={{ marginTop: 40 }}>
        <Button fullWidth disabled={submitted} loading={submitted} variation="alternate">
          redefinir senha
        </Button>
      </div>
    </FormElement>
  );
};
